export const animationStyle = {
  auction_new: 'gray',
  auction_not_active: 'gray',
  auction_active: 'green',
  auction_finishing: 'yellow',
  auction_finished: 'red',
};
